import type { SVGProps } from 'react';

/**
 * Widget card icons - exact artwork from the Figma Widgets view (Lucide-style 2px strokes,
 * white body fills as rendered in the design). Strokes inherit the current text color.
 */

export function PromiseDateIcon({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 30 30"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path d="M10 2.5V7.5" />
      <path d="M20 2.5V7.5" />
      <path
        d="M26.25 17.5V7.5C26.25 6.83696 25.9866 6.20107 25.5178 5.73223C25.0489 5.26339 24.413 5 23.75 5H6.25C5.58696 5 4.95107 5.26339 4.48223 5.73223C4.01339 6.20107 3.75 6.83696 3.75 7.5V25C3.75 25.663 4.01339 26.2989 4.48223 26.7678C4.95107 27.2366 5.58696 27.5 6.25 27.5H16.25"
        fill="white"
      />
      <path d="M3.75 12.5H26.25" />
      <path d="M20 25L22.5 27.5L27.5 22.5" />
    </svg>
  );
}

export function FreeShippingCountdownIcon({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path d="M28 16C27.9999 18.5341 27.1975 21.0031 25.7079 23.0532C24.2183 25.1033 22.1179 26.6292 19.7078 27.4122C17.2977 28.1952 14.7016 28.1951 12.2915 27.412C9.88145 26.6289 7.78117 25.1029 6.29169 23.0527C4.8022 21.0025 3.99998 18.5334 4 15.9993C4.00002 13.4652 4.80227 10.9961 6.29179 8.946C7.7813 6.89585 9.88161 5.36988 12.2917 4.58677C14.7018 3.80366 17.2979 3.80362 19.708 4.58667" />
      <path d="M16.0004 7C17.901 7.00009 19.7528 7.60186 21.2904 8.71906C22.8279 9.83626 23.9723 11.4115 24.5596 13.2191C25.1469 15.0267 25.1468 16.9738 24.5594 18.7814C23.9721 20.5889 22.8276 22.1641 21.29 23.2812C19.7523 24.3983 17.9005 25 15.9999 25C14.0993 25 12.2476 24.3983 10.7099 23.2812C9.17233 22.164 8.02785 20.5888 7.44052 18.7812C6.85319 16.9737 6.85316 15.0266 7.44044 13.219" />
    </svg>
  );
}

export function OutOfHomePopupIcon({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path d="M9.33333 2.66667H22.6667" />
      <path d="M6.66667 8H25.3333" />
      <path
        d="M25.3333 13.3333H6.66667C5.19391 13.3333 4 14.5272 4 16V26.6667C4 28.1394 5.19391 29.3333 6.66667 29.3333H25.3333C26.8061 29.3333 28 28.1394 28 26.6667V16C28 14.5272 26.8061 13.3333 25.3333 13.3333Z"
        fill="white"
      />
    </svg>
  );
}
